import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import platePatternUtils from "../../../../../utils/plate-pattern-utils.js";

const ReportContent = ({data, tableColumns}) => {
    const columns = [
        {id: "login", label: "Agente", className: "w-[10%]", renderCell: element => element.login ?? ""},
        {id: "date_time", label: "Data/hora correção", className: "w-[10%]", renderCell: element => element.date_time ?? ""},
        {id: "old_plate", label: "Placa anterior", className: "w-[7%]", renderCell: element => <span style={{fontWeight: 700}}>{platePatternUtils.formatPlate(element.payload.oldPlate)}</span>},
        {id: "new_plate", label: "Placa corrigida", className: "w-[7%]", renderCell: element => <span style={{fontWeight: 700}}>{platePatternUtils.formatPlate(element.payload.newPlate)}</span>},
        {id: "capture_time", label: "Data/hora passagem", className: "w-[12%]", renderCell: element => element.capture_time ?? ""},
        {id: "camera", label: "Câmera", className: "w-[33%]", renderCell: element => element.payload.lane ?? ""},
        {id: "processing", label: "Processamento", className: "w-[11%]", renderCell: element => element.payload.procid ?? ""},
    ];
    const visibleColumns = columns.filter(column => tableColumns?.[column.id]?.visible !== false);

    useEffect(() => {
        ReportUtils.createExportableTable(null, null, `Correção de placas`, "fixed-plates-data");
    }, [data, tableColumns]);

    return (
        <>
            {visibleColumns.length === 0 ? (
                <div className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>
            ) : <table id="fixed-plates-data" className="table report-table" sheet-name="Correção de placas">
                <thead className="thead-background">
                    <tr className="bg-[#f6f6f6] text-left">
                        {visibleColumns.map(column => <th key={column.id} className={column.className}>{tableColumns?.[column.id]?.label ?? column.label}</th>)}
                    </tr>
                </thead>
                <tbody className="bg-white">
                    {data.map((element, index) => <tr key={index} className="table-break-word">{visibleColumns.map(column => <td key={column.id} className={column.className}>{column.renderCell(element)}</td>)}</tr>)}
                </tbody>
            </table>}

            <div id="chart-tables"/>

        </>
    );
};

export default ReportContent;